<div class="tabs">
  <div class="tabs-button-container">
    <div
      class="entire-comment-container"
      *ngIf="isGroupReading"
      (click)="_openPanel('comment')"
    >
      <button
        class="entire-comment"
        [class.is-active]="_activePanel === 'comment'"
      >
        <span>전체 댓글</span>
      </button>
    </div>

    <!-- 내 기록(그룹책) -->
    <div
      class="my-record-container"
      *ngIf="isGroupReading && _isOwnedByUser"
      (click)="_openPanel('myAnnotationsGroup')"
    >
      <button
        class="my-record"
        [class.is-active]="_activePanel === 'myAnnotationsGroup'"
      >
        <span>내 기록</span>
      </button>
    </div>

    <div
      class="member-record-container"
      *ngIf="isGroupReading && _isOwnedByUser"
      (click)="_openPanel('memberAnnotations')"
    >
      <button
        class="member-record"
        [class.is-active]="_activePanel === 'memberAnnotations'"
      >
        <span>멤버 기록</span>
      </button>
    </div>

    <!-- 내 기록(나의책) -->
    <div
      class="my-record-container"
      *ngIf="!isGroupReading && _isOwnedByUser"
      (click)="_openPanel('myAnnotations')"
    >
      <button
        class="my-record"
        [class.is-active]="_activePanel === 'myAnnotations'"
      >
        <span>내 기록</span>
      </button>
    </div>
    <!-- <button
      class="commentary"
      *ngIf="!isGroupReading"
      (click)="_openPanel('commentary')"
    >
      <span>코멘터리</span>
    </button> -->
  </div>

  <button
    class="close-button"
    [class.is-group-reading]="isGroupReading"
    sui-icon-button
    (click)="_onCloseButtonClick()"
  >
    <sui-icon name="엑스"></sui-icon>
  </button>
</div>

<!-- 전체 댓글 -->
<div class="panel" [class.is-active]="_activePanel === 'comment'">
  <viewer-reading-group-memo-list
    [isOwnedByUser]="_isOwnedByUser"
  ></viewer-reading-group-memo-list>
</div>

<!-- 내 기록(그룹책) -->
<div class="panel" [class.is-active]="_activePanel === 'myAnnotationsGroup'">
  <viewer-reading-group-records [isMine]="true"></viewer-reading-group-records>
</div>

<!-- 멤버 기록(그룹책) -->
<div class="panel" [class.is-active]="_activePanel === 'memberAnnotations'">
  <viewer-reading-group-records
    [isMine]="false"
    [memberId]="_memberId"
    [memberName]="_memberName"
  ></viewer-reading-group-records>
</div>

<!-- 내 기록(나의책) -->
<div class="panel" [class.is-active]="_activePanel === 'myAnnotations'">
  <viewer-annotations></viewer-annotations>
</div>

<!-- 코멘터리 -->
<!-- <div class="panel" [class.is-active]="_activePanel === 'commentary'">
  <viewer-annotations></viewer-annotations>
</div> -->
